
export const styles = {
    avatar : {
        color: 'black',
        backgroundColor: '#eeaab9',
    }
}